import React from "react";

/*
    Close Menu Icon
    props:
        - title: string, override the default title 'Close Menu'
        - color: string, override the default color '#00549A' (bell blue)
*/

const CloseMenuIcon = (props) => (
    <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Close Menu"}</title>
        <path
            d="M3.75 3.75L12 12M20.25 20.25L12 12M12 12L20.25 3.75M12 12L3.75 20.25"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CloseMenuIcon;
